import gql from 'graphql-tag';

export default gql`
mutation linkObjectives(
    $elementId: UUID!,
    $elementType: CoursewareElementType,
    $documentItems: [DocumentItemInputInput],
  ) {
    competencyDocumentItemLink (input: {
      elementId: $elementId,
      elementType: $elementType,
      documentItems: $documentItems
    }) {
      documentLink {
        elementId
        elementType
        documentItems {
          documentId
          documentItemId
        }
      }
    }
  }
`;
